<template>

    <div class="overflow-auto" style="max-height: 40vh;">
        <div class="d-flex justify-content-between align-items-center my-3">
            <div>
                <strong>Nightly Rate Total</strong>
            </div>
            <div>{{ money(quote.nightly) }}</div>
        </div>

        <div v-for="(fee, index) in quote.fees" :key="`quote-${property.id}-fee-${index}`" class="small d-flex justify-content-between align-items-center my-3">
            <div>
                {{ fee.name }}
                <i v-if="fee.isServiceFee" class="fas fa-info-circle ms-1 clickable" @click.prevent="showServiceFeeAgreement"></i>
                <tooltip v-else-if="fee.tooltip" :title="fee.tooltip">
                    <i class="fas fa-info-circle ms-1"></i>
                </tooltip>
                
            </div>
            <div v-if="fee.amount">{{ money(fee.amount) }}</div>
            <div v-else>Included</div>
        </div>

        <div v-if="quote.coverage" class="small d-flex justify-content-between align-items-center my-3">
            <div>
                Travel Protection
            </div>
            <div>{{ money(quote.coverage) }}</div>
        </div>

        <div v-if="quote.taxes" class="small d-flex justify-content-between align-items-center my-3">
            <div>Taxes</div>
            <div>{{ money(quote.taxes) }}</div>
        </div>

        <div v-if="quote.discount" class="small d-flex justify-content-between align-items-center my-3">
            <div>Gift Code {{ quote.discount.code ? `(${quote.discount.code})` : '' }}</div>
            <div>({{ money(quote.discount.amount) }})</div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Analytics from '@/classes/Analytics.js';
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';
    import Formatter from '@/classes/Formatter.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },


            quote: {
                type: Object,
                required: true,
            },

        },

        methods: {
            money(amount) {
                return Formatter.money(amount);
            },

            showServiceFeeAgreement() {
                Analytics.gEvent('PfClickQuote');
                window.open('/terms/service-fee');
            },
        }
    };

</script>
